import { useConnection } from '@estream/sdk-browser/react';
import './Settings.css';

export default function Settings() {
  const { state, network } = useConnection();
  
  return (
    <div className="settings-page animate-in">
      {/* Connection Settings */}
      <section className="card">
        <h2 className="card-title">Connection</h2>
        
        <div className="settings-grid">
          <div className="setting-item">
            <label className="setting-label">Network</label>
            <div className="setting-value">
              <code>{network}</code>
            </div>
          </div>
          
          <div className="setting-item">
            <label className="setting-label">Edge URL</label>
            <div className="setting-value">
              <code>{import.meta.env.VITE_EDGE_URL || 'https://edge.estream.dev:4433'}</code>
            </div>
          </div>
          
          <div className="setting-item">
            <label className="setting-label">Connection Status</label>
            <div className="setting-value">
              <span className={`status-badge ${state}`}>{state}</span>
            </div>
          </div>
        </div>
      </section>
      
      {/* Appearance */}
      <section className="card">
        <h2 className="card-title">Appearance</h2>
        
        <div className="settings-grid">
          <div className="setting-item">
            <label className="setting-label">Theme</label>
            <div className="setting-value">
              <select className="select">
                <option value="dark">Dark</option>
                <option value="light" disabled>Light (coming soon)</option>
              </select>
            </div>
          </div>
        </div>
      </section>
      
      {/* About */}
      <section className="card">
        <h2 className="card-title">About</h2>
        
        <div className="about-info">
          <p><strong>eStream Console</strong> v0.4.0</p>
          <p className="text-muted">
            Built with @estream/sdk-browser and React.
          </p>
          <p className="text-muted">
            © 2026 eStream. All rights reserved.
          </p>
        </div>
      </section>
    </div>
  );
}
